import { X } from "lucide-react"

interface IdleSessionModalProps {
  isOpen: boolean
  onStayActive: () => void
  onLogout: () => void
}

export function IdleSessionModal({ isOpen, onStayActive, onLogout }: IdleSessionModalProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[999999] flex items-center justify-center bg-black/40 backdrop-blur-sm">
      <div className="bg-white rounded-xl shadow-2xl border border-gray-100 p-8 w-full max-w-md mx-4 relative">
        {/* Close button - optional, can be removed if not needed */}
        <button
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
          onClick={onStayActive}
        >
          <X className="w-5 h-5" />
        </button>

        {/* Header */}
        <div className="text-center mb-8">
          <div className="w-12 h-12 bg-indigo-50 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg className="w-6 h-6 text-indigo-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          </div>
          <h3 className="text-xl font-semibold text-gray-900 mb-2">Session Timeout</h3>
          <p className="text-gray-600 leading-relaxed">
            You've been idle for a while. Would you like to extend your session or log out for security?
          </p>
        </div>

        {/* Action Buttons */}
        <div className="flex gap-3">
          <button
            onClick={onLogout}
            className="flex-1 h-11 px-4 rounded-lg border border-indigo-500 bg-indigo-50 text-indigo-700 font-medium hover:bg-indigo-100 transition-colors shadow-sm"
          >
            Log Me Out
          </button>
          <button
            onClick={onStayActive}
            className="flex-1 h-11 px-4 rounded-lg bg-gradient-to-b from-indigo-400 to-indigo-600 text-white font-medium hover:from-indigo-500 hover:to-indigo-700 transition-all shadow-sm hover:shadow-md"
          >
            Stay Active
          </button>
        </div>

        {/* Footer text */}
        <p className="text-xs text-gray-500 text-center mt-6">
          For your security, inactive sessions are automatically logged out
        </p>
      </div>
    </div>
  )
}